<nz-layout>
     
      <nz-header>   
                
          <div class="header-item">
            <div class="logo">
              <a href="/">
                <img src="assets/logo.png" alt="logo">
                <h1 class="title">{{title}}</h1>           
                <sup class="version">{{version}}</sup>
              </a>        
            </div>
          </div>

          <div class="header-item" style="width:100%"></div>

          <div class="header-item">
            
              <ul nz-menu nzTheme="dark" nzMode="horizontal">
                @if (isAuthenticated) {
                    <li nz-submenu [nzTitle]="logoutTpl" nzIcon="setting" [nzPlacement]="'bottomRight'">
                      <ng-template #logoutTpl> 
                        <button nz-button nzType="link" style="height:48px">
                        <span><img style="height:36px;border:1px solid #fff;border-radius:50%" src="{{ user.picture }}"/>
                          {{ user.email }}                
                        </span>           
                      </button>                                        
                      </ng-template>
                      <ul>                            
                            <li nz-menu-item><a routerLink="/profile"><i class="fa-solid fa-user"></i>Profile</a></li>      
                            <li nz-menu-item (click)="logout()"><i class="fa fa-close"></i> Abmelden</li>                                                      
                      </ul>
                    </li>
                }
                @else {                  
                    <li nz-submenu [nzTitle]="loginTpl" nzIcon="setting" [nzPlacement]="'bottomRight'">
                      <ng-template #loginTpl>                  
                        <button nz-button nzType="primary" style="height:48px" (click)="login()"><i class="fa fa-user"></i> Anmelden</button>                                           
                      </ng-template>                      
                    </li>
              }                    
              </ul>      
        </div>
        
      </nz-header>
      


      <nz-layout>        
          <nz-sider nzCollapsible nzWidth="256px" nzBreakpoint="md" [(nzCollapsed)]="isCollapsed" [nzCollapsedWidth]="44">        
                  <ul nz-menu nzTheme="dark" nzMode="inline" [nzInlineCollapsed]="isCollapsed">
                      <li nz-menu-item nzMatchRouter>
                        <a routerLink="/dashboard"><i class="fa-solid fa-home"></i> Dashboard</a>
                      </li>

                      <ng-container *roleCheck="{user, roles: ['admin']}">
                        <ul nz-submenu  nzTitle="PIM Media" nzTheme="dark" nzMode="inline" nzOpen>                          
                                <ul nz-menu nzTheme="dark" nzMode="inline">                            
                              <li nz-menu-item nzMatchRouter>      
                                <a routerLink="/imageBox"><img class="icon" src="assets/dashboard/imageBox.svg"> imageBox</a>      
                              </li>
                            </ul>                          
                        </ul>
                    </ng-container>


                      <ng-container *roleCheck="{user, roles: ['admin']}">
                        <ul nz-submenu  nzTitle="Barth Medienhaus" nzTheme="dark" nzMode="inline">                          
                                <ul nz-menu nzTheme="dark" nzMode="inline">                              
                              <li nz-menu-item nzMatchRouter>      
                                <a routerLink="/flyer"><img class="icon" src="assets/dashboard/flyer.svg"> Flyer</a>      
                              </li>                              
                              <li nz-menu-item nzMatchRouter>      
                                <a routerLink="/search"><i class="fa-solid fa-magnifying-glass"></i> Suche</a>      
                              </li>                            
                            </ul>                          

                        </ul>
                    </ng-container>
                  
                  </ul>
          </nz-sider>
       
        <nz-content>              
          <div id="content" #content>   
            <router-outlet></router-outlet>                           
            <nz-back-top [nzTarget]="content"></nz-back-top>
          </div>    
        </nz-content>
      
        
      </nz-layout>
</nz-layout>